(function (runtime) {
    "use strict";

    var STATUS_PATH = "raffle/status";
    var ENTRY_PATH = "raffle/entry";
    // 外部照会が遅いと、既定の8秒では画面がエラーでもサーバーは応募を受理しうる。
    // この食い違いを減らすため、応募・取り消しは会員ページの購入ボタンと同じ25秒待つ。
    var ENTRY_TIMEOUT_MS = 25000;
    // #437: サーバーの入れ替え（10秒ほど）の間に押すと、申し込みが届かずエラーになっていた。
    // 届かなかったかもしれない失敗のときだけ、間を空けて最大3回まで自動で送り直す（間はおよそ2・5・10秒）。
    // 応募も取り消しも、同じものが2回届いても結果は同じ（応募済み／取り消し済みで返る）なので送り直して安全。
    // 時間切れ（25秒）は送り直さない（サーバーが受け付けている途中かもしれず、待ち時間も長くなるため）。
    var ENTRY_RETRY_DELAYS_MS = [2000, 5000, 10000];
    // 最初に押してからこれを過ぎたら送り直さない（ボタンが「送信中」のまま長く止まらないように）
    var ENTRY_RETRY_BUDGET_MS = 40000;
    var MINUTE_MS = 60 * 1000;
    var HOUR_MS = 60 * MINUTE_MS;
    var DAY_MS = 24 * HOUR_MS;
    // 不正な識別子でサーバーの回数制限を消費しないため。
    var RAFFLE_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/;
    // 応募済みのボタンに足す目印。色とチェックの見た目は節のCSSが持つ。
    var ENTERED_CLASS = "nk-rf__btn--entered";
    // 帯の文言。締切後・抽選前の応募者には「応募済み（結果は締切のあと）」。
    // 抽選が終わった帯（stage_ended）はオーナー決定 2026-09-21 で出さない（灰色ボタンだけ）。文言キーは liquid 側に残る。
    var STAGE_TEXT_KEYS = {
        entered_waiting: "stageEnteredWaiting"
    };
    var NOTICE_TEXT_KEYS = {
        account_notice: "noticeAccount",
        contact_notice: "noticeContact",
        // store #440: 当選の購入の権利が購入のないまま過ぎた方は、しばらく申し込めない（文は「一時的に」だけ）
        entry_paused: "noticePaused"
    };
    var NOTICE_CTA_KEYS = {
        account_notice: "noticeAccountCta",
        contact_notice: "noticeContactCta",
        // ボタンは「Contact us」（account_notice と同じ文・同じ行き先）
        entry_paused: "noticeAccountCta"
    };
    var controllers = typeof WeakMap === "function" ? new WeakMap() : null;

    function find(scope, name) {
        return scope.querySelector('[data-nk-raffle="' + name + '"]');
    }

    function setText(element, value) {
        if (element) {
            element.textContent = value === null || value === undefined
                ? ""
                : String(value);
        }
    }

    function setHidden(element, hidden) {
        if (element) {
            element.hidden = Boolean(hidden);
        }
    }

    function datasetText(root, name) {
        var value = root.dataset[name];
        return value === undefined ? "" : value;
    }

    function fillTemplate(template, values) {
        return String(template).replace(
            /\{\{\s*([a-z_]+)\s*\}\}|\{([a-z_]+)\}/g,
            function (whole, doubleKey, singleKey) {
                var key = doubleKey || singleKey;
                return Object.prototype.hasOwnProperty.call(values, key)
                    ? String(values[key])
                    : whole;
            }
        );
    }

    function parseTime(value) {
        if (typeof value !== "string" || value.trim() === "") {
            return null;
        }
        var text = value.trim();
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]00:00)$/i.test(text)) {
            return null;
        }
        var parsed = Date.parse(text);
        return Number.isNaN(parsed) ? null : parsed;
    }

    function validRaffleId(value) {
        return typeof value === "string" && RAFFLE_ID_PATTERN.test(value);
    }

    function noticeHref(value) {
        var text = typeof value === "string" ? value.trim() : "";
        // テーマ属性が壊れていても、通知から外部のスキームへ誘導しないため。
        return /^\/(?!\/)/.test(text) && !/[\\\u0000-\u001f\u007f]/.test(text)
            ? text
            : "";
    }

    function loginHref(base, location) {
        // 応募のためにログインした人を、元のトップページへ確実に戻すため。
        if (typeof runtime.URL !== "function" || !location || !location.href) {
            return base;
        }
        try {
            var url = new runtime.URL(base, location.href);
            var back = location.pathname + location.search;
            // 新しいログイン方式（customer_authentication）は Shopify 公式の
            // /customer_authentication/login?return_to=<同じお店の中の住所> でだけ元のページへ戻る（2026-10-07 公開当日に実測）。
            // 旧方式に戻したときは今までどおり return_url。
            if (url.pathname.indexOf("/customer_authentication/") === 0) {
                url = new runtime.URL("/customer_authentication/login", location.href);
                url.searchParams.set("return_to", back);
            } else {
                url.searchParams.set("return_url", back);
            }
            return url.toString();
        } catch (error) {
            return base;
        }
    }

    function localizedTime(locale, value) {
        var parsed = parseTime(value);
        if (parsed === null) {
            return "";
        }
        var date = new Date(parsed);
        try {
            return new Intl.DateTimeFormat(locale || undefined, {
                // 年は出さない（2026-09-06 オーナー決定・#144）。
                // 当選期限は当選から24時間なので、年が無くても日付を取り違えようがない。
                // ⚠️ 予備の書き方（下の catch）は ISO の文字列で年を含む。ここは
                //    Intl が使えない古い環境だけの最後の受け皿なので、読めることを優先する。
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23"   // 決定118: 24時間表記（英語で 12:00 AM/PM と出て12時間ずれるのを防ぐ）
            }).format(date);
        } catch (error) {
            return date.toISOString().replace("T", " ").slice(0, 16) + "Z";
        }
    }

    /* 2026-09-22 オーナー決定: 写真の枠の外・上に出す「締切の日付」。
       ・ふだんは日付だけ（例 Thu, Sep 24）。時刻は出さない（真下のカウントダウンが正確に伝える）
       ・お客さまの現地の日付で「今日」なら「本日締切」に差し替える
       ⚠️ 年は出さない（決定・#144 と同じ扱い） */
    function localizedDate(locale, value) {
        /* 🛑 value は「ISOの文字列」と「すでに数値になったミリ秒」の両方が来る。
              parseTime は文字列しか受け付けないので、数値をそのまま渡すと null → 空文字になり、
              日付の行が出なくなる（2026-09-22 に実物で踏んだ）。両方を受ける。 */
        var parsed = typeof value === "number" ? value : parseTime(value);
        if (parsed === null || Number.isNaN(parsed)) {
            return "";
        }
        var date = new Date(parsed);
        try {
            return new Intl.DateTimeFormat(locale || undefined, {
                weekday: "short",
                month: "short",
                day: "numeric"
            }).format(date);
        } catch (error) {
            return date.toISOString().slice(0, 10);
        }
    }

    function isSameLocalDay(ms, nowMs) {
        var a = new Date(ms);
        var b = new Date(nowMs);
        return a.getFullYear() === b.getFullYear()
            && a.getMonth() === b.getMonth()
            && a.getDate() === b.getDate();
    }

    function updateCloseDate(state, item, nowMs, closed) {
        if (!item.closeDate) {
            return;
        }
        if (closed) {
            // オーナー決定 2026-09-22（決定164 の続き）: 終わった回は日付でなく「終了しました」。
            // 過ぎた日付をそのまま出すと、これから応募できる予定のように見えるため。
            // 見える場面＝締切をまたいで開きっぱなしのタブ（読み直すとカードごと節から消える）。
            // ⚠️ closed_label（「応募は締め切りました」）ではなく stage_ended を使う。理由は2つ:
            //    ①すぐ下の灰色ボタンが「Entry closed」なので、締切の言葉だと同じことを2回言う形に戻る
            //      （オーナー指摘「締め切られましたの表示が3つくらいありくどい」＝決定164 の発端）
            //    ②引きは締切と同時刻（どちらも 15:50 UTC＝日本時間 0:50）なので、
            //      「締切は過ぎたが引きはまだ」の時間帯は数分しかない
            // 🛑 文言が届かないときは空の行を残さず隠す（中身の無い枠が出るため）。
            setHidden(item.closeDate, !state.texts.stageEnded);
            setText(item.closeDate, state.texts.stageEnded || "");
            return;
        }
        if (item.closesAt === null) {
            setText(item.closeDate, "");
            setHidden(item.closeDate, true);
            return;
        }
        var text = isSameLocalDay(item.closesAt, nowMs)
            ? (state.texts.closesToday || "")
            : localizedDate(state.locale, item.closesAt);
        if (!text) {
            setHidden(item.closeDate, true);
            return;
        }
        setText(item.closeDate, text);
        setHidden(item.closeDate, false);
    }

    function readTexts(root) {
        return {
            enter: datasetText(root, "nkRaffleEnter"),
            entering: datasetText(root, "nkRaffleEntering"),
            withdraw: datasetText(root, "nkRaffleWithdraw"),
            withdrawing: datasetText(root, "nkRaffleWithdrawing"),
            signin: datasetText(root, "nkRaffleSignin"),
            notOpenYet: datasetText(root, "nkRaffleNotOpenYet"),
            closedButton: datasetText(root, "nkRaffleClosedButton"),
            closedLabel: datasetText(root, "nkRaffleClosedLabel"),
            countdownDays: datasetText(root, "nkRaffleCountdownDays"),
            countdownHours: datasetText(root, "nkRaffleCountdownHours"),
            countdownMinutes: datasetText(root, "nkRaffleCountdownMinutes"),
            countdownSoon: datasetText(root, "nkRaffleCountdownSoon"),
            deadlineNote: datasetText(root, "nkRaffleDeadlineNote"),
            deadlineNoteGuest: datasetText(root, "nkRaffleDeadlineNoteGuest"),
            enteredButton: datasetText(root, "nkRaffleEnteredButton"),
            enteredNote: datasetText(root, "nkRaffleEnteredNote"),
            stageEnteredWaiting: datasetText(root, "nkRaffleStageEnteredWaiting"),
            stageEnded: datasetText(root, "nkRaffleStageEnded"),
            offerTitle: datasetText(root, "nkRaffleOfferTitle"),
            offerDeadline: datasetText(root, "nkRaffleOfferDeadline"),
            offerCta: datasetText(root, "nkRaffleOfferCta"),
            offerCtaAccount: datasetText(root, "nkRaffleOfferCtaAccount"),
            enteredOk: datasetText(root, "nkRaffleEnteredOk"),
            withdrawnOk: datasetText(root, "nkRaffleWithdrawnOk"),
            noticeAccount: datasetText(root, "nkRaffleNoticeAccount"),
            noticeContact: datasetText(root, "nkRaffleNoticeContact"),
            noticeAccountCta: datasetText(root, "nkRaffleNoticeAccountCta"),
            noticeContactCta: datasetText(root, "nkRaffleNoticeContactCta"),
            noticePaused: datasetText(root, "nkRaffleNoticePaused"),
            rateLimited: datasetText(root, "nkRaffleRateLimited"),
            loadError: datasetText(root, "nkRaffleLoadError"),
            retry: datasetText(root, "nkRaffleRetry"),
            actionError: datasetText(root, "nkRaffleActionError"),
            // 2026-09-22 オーナー決定: 写真の枠の外・上に「締切の日付」を出す。当日は「本日締切」
            closesToday: datasetText(root, "nkRaffleClosesToday"),
            // 2026-10-12（store #415）: 応募の前の確認の窓の説明と「Not now」
            confirmBody: datasetText(root, "nkRaffleConfirmBody"),
            confirmWarn: datasetText(root, "nkRaffleConfirmWarn"),
            confirmCancel: datasetText(root, "nkRaffleConfirmCancel")
        };
    }

    function collectItems(state) {
        var nodes = Array.prototype.slice.call(
            state.root.querySelectorAll("[data-nk-raffle-item]")
        );
        return nodes.map(function (element) {
            return {
                element: element,
                raffleId: element.getAttribute("data-nk-raffle-id") || "",
                closesAt: parseTime(element.getAttribute("data-nk-raffle-closes-at")),
                url: element.getAttribute("data-nk-raffle-url") || "",
                // 商品ページだけが持つ。当選の案内の飛び先を会員ページ（棚の「買う」）にする（#192）。
                offerUrl: element.getAttribute("data-nk-raffle-offer-url") || "",
                // #415: 確認の窓に出す作品名と写真（品のページの応募欄には写真も名前も無いので、品の目印に持たせる）
                title: element.getAttribute("data-nk-raffle-title") || "",
                image: element.getAttribute("data-nk-raffle-image") || "",
                closeDate: find(element, "close-date"),
                countdown: find(element, "countdown"),
                countdownRow: find(element, "countdown-row"),
                closedLabel: find(element, "closed-label"),
                stage: find(element, "stage"),
                offer: find(element, "offer"),
                offerDeadline: find(element, "offer-deadline"),
                offerCta: find(element, "offer-cta"),
                // #301: 商品ページだけが持つ。当選した人がここから買う2つのボタン
                ownBuy: find(element, "own-buy"),
                notice: find(element, "notice"),
                noticeText: find(element, "notice-text"),
                noticeCta: find(element, "notice-cta"),
                enter: find(element, "enter"),
                withdraw: find(element, "withdraw"),
                signin: find(element, "signin"),
                deadlineNote: find(element, "deadline-note"),
                status: find(element, "status"),
                mode: "loading",
                data: null,
                busy: false,
                confirming: false,
                loading: null,
                revision: 0,
                actionBlock: ""
            };
        });
    }

    function setButton(element, label, enabled) {
        if (!element) {
            return;
        }
        setText(element, label);
        element.hidden = false;
        element.disabled = !enabled;
    }

    // 応募済みの見た目（苔色＋チェック）の付け外し。
    // ⚠️ 付けるのは1か所だけ。外すのは毎回の描画の入口で必ず1回。
    //    こうしないと、取り消したあとも色が残る（前の描画の見た目が居座る）。
    function setEnteredLook(item, entered) {
        if (!item.enter || !item.enter.classList) {
            return;
        }
        if (entered) {
            item.enter.classList.add(ENTERED_CLASS);
        } else {
            item.enter.classList.remove(ENTERED_CLASS);
        }
    }

    function showStatus(state, item, message) {
        if (!item.status) {
            return;
        }
        setText(item.status, message);
        setHidden(item.status, !message);
    }

    function measure(element, name) {
        var value = element ? element[name] : 0;
        return typeof value === "number" && isFinite(value) ? value : 0;
    }

    function updateRail(state) {
        // 横にはみ出しているかは、実際に描いたブラウザにしか分からない。
        // 出っぱなしにせず、はみ出しているときだけ帯を出す。
        if (!state.rail) {
            return;
        }
        var box = state.itemsBox;
        var visible = measure(box, "clientWidth");
        var total = measure(box, "scrollWidth");
        var overflow = total - visible;

        if (!box || visible <= 0 || overflow <= 1) {
            state.rail.hidden = true;
            return;
        }
        state.rail.hidden = false;

        if (!state.railThumb || !state.railThumb.style) {
            return;
        }
        var ratio = visible / total;
        var progress = Math.min(1, Math.max(0, measure(box, "scrollLeft") / overflow));
        state.railThumb.style.width = (ratio * 100) + "%";
        // 帯の中を動かすので、つまみの幅ぶんだけ動ける幅が減る。
        state.railThumb.style.transform =
            "translateX(" + (progress * (100 / ratio - 100)) + "%)";
    }

    function setupRail(state) {
        if (!state.rail) {
            return;
        }
        var onChange = function () {
            updateRail(state);
        };
        if (state.itemsBox && typeof state.itemsBox.addEventListener === "function") {
            state.itemsBox.addEventListener("scroll", onChange);
            state.railListeners.push([state.itemsBox, "scroll", onChange]);
        }
        if (typeof runtime.addEventListener === "function") {
            runtime.addEventListener("resize", onChange);
            state.railListeners.push([runtime, "resize", onChange]);
            // 幅が変わると折り返しが変わるので、行の高さもそろえ直す（#273）
            var onResize = function () {
                equalizeRows(state);
            };
            runtime.addEventListener("resize", onResize);
            state.railListeners.push([runtime, "resize", onResize]);
        }
        updateRail(state);
    }

    // 同じ列に並んだカードで、「日付の行」と「残り時間の行」の高さをそろえる（#273）。
    // 言語や文言の長さで片方のカードだけ2行に折れると、その下の応募ボタンの位置がずれる
    // （実測: 独語・834px で「Teilnahmeschluss heute, 23:50」だけが2行になり 12px ずれた）。
    // 全カードに2行ぶんの空きを常に取ると大半のカードに余白が出るので、
    // いちばん高いカードにだけ合わせる。トップの並べる形（grid）だけ（一覧は1品ずつ）。
    function equalizeRows(state) {
        var box = state.itemsBox;
        if (!box || typeof box.querySelectorAll !== "function" || typeof box.closest !== "function"
            || !box.closest(".nk-rf--grid")) {
            return;
        }
        ["[data-nk-raffle=\"close-date\"]", ".nk-rf__stateline"].forEach(function (selector) {
            var list = Array.prototype.slice.call(box.querySelectorAll(selector));
            list.forEach(function (element) {
                if (element.style) { element.style.minHeight = ""; }
            });
            var tallest = 0;
            list.forEach(function (element) {
                if (element.hidden || typeof element.getBoundingClientRect !== "function") { return; }
                var height = element.getBoundingClientRect().height;
                if (height > tallest) { tallest = height; }
            });
            if (tallest > 0) {
                list.forEach(function (element) {
                    if (element.style) { element.style.minHeight = tallest + "px"; }
                });
            }
        });
    }

    function updateBand(state) {
        // 帯は「読めなかった」ときだけ。404（口が隠れている）では出さない。
        var failed = state.items.some(function (item) {
            return item.mode === "error" && !item.element.hidden;
        });
        setHidden(state.band, !failed);
    }

    function updateCountdown(state, item, nowMs, closed) {
        updateCloseDate(state, item, nowMs, closed);
        // 残り12時間未満だけ印を付ける。締切後・日付なし・時刻の巻き戻しでは外す。
        var isSoon = !closed && item.closesAt !== null
            && item.closesAt > nowMs && item.closesAt - nowMs < 12 * HOUR_MS;
        if (isSoon) { item.element.classList.add("is-soon"); }
        else { item.element.classList.remove("is-soon"); }
        if (closed) {
            // 締切の案内はボタンだけにまとめる。
            setHidden(item.countdown, true);
            setHidden(item.countdownRow, true);
            setHidden(item.closedLabel, true);
            return;
        }
        if (item.closesAt === null) {
            setText(item.countdown, "");
            setHidden(item.countdown, true);
            setHidden(item.countdownRow, true);
            setHidden(item.closedLabel, true);
            return;
        }
        setHidden(item.countdown, false);

        var remaining = Math.max(0, item.closesAt - nowMs);
        var days = Math.floor(remaining / DAY_MS);
        var hours = Math.floor((remaining % DAY_MS) / HOUR_MS);
        var minutes = Math.floor((remaining % HOUR_MS) / MINUTE_MS);
        var seconds = Math.floor((remaining % MINUTE_MS) / 1000);
        var values = {
            days: String(days),
            hours: days > 0 ? String(hours).padStart(2, "0") : String(hours),
            minutes: days > 0 || hours > 0 ? String(minutes).padStart(2, "0") : String(minutes)
        };
        var text;

        if (days > 0) {
            text = fillTemplate(state.texts.countdownDays, values);
        } else if (hours > 0) {
            text = fillTemplate(state.texts.countdownHours, values);
        } else if (minutes > 0) {
            text = fillTemplate(state.texts.countdownMinutes, values);
        } else {
            text = "";
        }

        text += (text ? " " : "") + (days > 0 || hours > 0 || minutes > 0
            ? String(seconds).padStart(2, "0") : String(seconds)) + "s";
        if (item.countdown) {
            item.countdown.style.fontVariantNumeric = "tabular-nums";
        }
        setText(item.countdown, text);
        setHidden(item.countdownRow, false);
        setHidden(item.closedLabel, true);
    }

    function hideExtras(item) {
        setHidden(item.stage, true);
        setHidden(item.offer, true);
        setHidden(item.notice, true);
    }

    function renderNotice(state, item, notice) {
        var textKey = NOTICE_TEXT_KEYS[notice];
        if (!textKey) {
            setHidden(item.notice, true);
            return false;
        }
        if (item.noticeText) {
            setText(item.noticeText, state.texts[textKey]);
        } else if (item.notice) {
            var ctaWasChild = item.noticeCta && item.noticeCta.parentNode === item.notice;
            setText(item.notice, state.texts[textKey]);
            if (ctaWasChild) {
                item.notice.appendChild(item.noticeCta);
            }
        }
        if (item.noticeCta) {
            setText(item.noticeCta, state.texts[NOTICE_CTA_KEYS[notice]]);
            var href = state.noticeUrls[notice];
            if (href) {
                item.noticeCta.setAttribute("href", href);
            }
            item.noticeCta.hidden = !href;
        }
        setHidden(item.notice, false);
        return true;
    }

    function renderOffer(state, item, offer) {
        if (!offer || typeof offer !== "object" || !offer.deadline_at) {
            setHidden(item.offer, true);
            return;
        }
        setText(item.offerDeadline, fillTemplate(state.texts.offerDeadline, {
            deadline: localizedTime(state.locale, offer.deadline_at)
        }));
        // #301（2026-09-26 オーナー決定・B案）: 商品ページでは当選した人がここから買う。
        //   部品（nk-own-purchase.js）が読めないときだけ、今までどおり会員ページへの入口に戻す。
        var ownPurchase = runtime.NKOwnPurchase;
        if (item.ownBuy && ownPurchase && typeof ownPurchase.bind === "function" && item.raffleId) {
            ownPurchase.bind(item.ownBuy, function () {
                return {path: ownPurchase.rafflePath, body: {raffle_id: item.raffleId}};
            });
            item.ownBuy.hidden = false;
            if (item.offerCta) {
                item.offerCta.hidden = true;
            }
            setHidden(item.offer, false);
            return;
        }
        if (item.offerCta) {
            // 商品ページは会員ページの棚へ（買うのはそこ・#192）。トップは従来どおり品のページへ。
            var target = item.offerUrl || item.url;
            setText(item.offerCta, item.offerUrl && state.texts.offerCtaAccount
                ? state.texts.offerCtaAccount : state.texts.offerCta);
            if (target) {
                item.offerCta.setAttribute("href", target);
                item.offerCta.hidden = false;
            } else {
                item.offerCta.hidden = true;
            }
        }
        setHidden(item.offer, false);
    }

    function viewerState(value) {
        var source = value && typeof value === "object" ? value : {};
        var offer = source.offer && typeof source.offer === "object"
            ? {deadline_at: source.offer.deadline_at}
            : null;
        return {
            event_state: typeof source.event_state === "string"
                ? source.event_state
                : "",
            viewer_stage: typeof source.viewer_stage === "string"
                ? source.viewer_stage
                : "",
            offer: offer,
            notice: typeof source.notice === "string" ? source.notice : ""
        };
    }

    function render(state, item) {
        var nowMs = state.now();
        var closed = item.actionBlock === "closed"
            || (item.closesAt !== null && nowMs >= item.closesAt);

        updateCountdown(state, item, nowMs, closed);
        if (item.busy) {
            // 送信中は前の見た目のまま待つ（取り消し中に色だけ先に戻ると、
            // まだ済んでいない取り消しが済んだように見える）。
            return;
        }
        setEnteredLook(item, false);

        if (item.mode === "guest") {
            hideExtras(item);
            setHidden(item.withdraw, true);
            setText(item.deadlineNote, state.texts.deadlineNoteGuest);
            if (closed) {
                // 締め切った品に「ログインして応募」を出すと、もうできないことを勧めてしまう。
                setHidden(item.signin, true);
                setButton(item.enter, state.texts.closedButton, false);
                // 決定164: 終わった回は灰色のボタン1つだけ。応募のしかたの説明も出さない。
                // 🛑 会員の枝と違い、ここは上で必ず文言を入れ直すので、隠すのを忘れると
                //    未ログインの人にだけ説明文が残り続ける（2026-09-22 に実測）。
                setHidden(item.deadlineNote, true);
                return;
            }
            setHidden(item.deadlineNote, false);
            setHidden(item.enter, true);
            if (item.signin) {
                setText(item.signin, state.texts.signin);
                item.signin.setAttribute("href", state.loginHref);
                item.signin.hidden = false;
            }
            return;
        }

        setHidden(item.signin, true);
        setText(item.deadlineNote, state.texts.deadlineNote);
        // 決定164: 終わった回は灰色のボタン1つだけ。応募のしかたの説明は出さない。
        // 🛑 ここで1回だけ決める。この下には途中で return する枝が4つ（読み込み中・関所閉・
        //    読めなかった・お知らせ付き）あり、枝ごとに隠していると必ずどれかを取りこぼす
        //    （実際に未ログインの枝で取りこぼしていた＝2026-09-22）。
        setHidden(item.deadlineNote, closed);

        if (item.mode === "loading") {
            hideExtras(item);
            setButton(
                item.enter,
                closed ? state.texts.closedButton : state.texts.enter,
                false
            );
            setHidden(item.withdraw, true);
            return;
        }

        if (item.mode === "gate_closed") {
            // 口が隠れているだけ。写真も残り時間もそのまま出し、警告は出さない。
            hideExtras(item);
            setButton(
                item.enter,
                closed ? state.texts.closedButton : state.texts.notOpenYet,
                false
            );
            setHidden(item.withdraw, true);
            return;
        }

        if (item.mode === "error") {
            hideExtras(item);
            setButton(
                item.enter,
                closed ? state.texts.closedButton : state.texts.enter,
                false
            );
            setHidden(item.withdraw, true);
            return;
        }

        var data = item.data || {};
        if (data.event_state && data.event_state !== "open" && !closed) {
            updateCountdown(state, item, nowMs, true);
        }
        if (renderNotice(state, item, data.notice)) {
            setHidden(item.stage, true);
            setHidden(item.offer, true);
            setButton(item.enter, state.texts.enter, false);
            setHidden(item.withdraw, true);
            return;
        }
        setHidden(item.notice, true);

        if (item.actionBlock === "not_open") {
            hideExtras(item);
            setButton(
                item.enter,
                closed ? state.texts.closedButton : state.texts.notOpenYet,
                false
            );
            setHidden(item.withdraw, true);
            return;
        }

        var stage = data.viewer_stage;
        var entered = stage === "entered_waiting";
        var openForEntry = data.event_state === "open" && !closed;

        renderOffer(state, item, data.offer);

        if (openForEntry) {
            setHidden(item.deadlineNote, false);
            // 受付中は、しるしの帯を出さない。応募済みかどうかはボタン自身が色と字で言う。
            setHidden(item.stage, true);
            if (entered) {
                // 🛑 ボタンは「エントリー済み」を名乗ったまま残す（消して入れ替えない）。
                //    消すと、同じ行の他のカードとボタンの位置がずれる。
                setButton(
                    item.enter,
                    // 文言が届かなかったときも、空のボタンにはしない。
                    state.texts.enteredButton || state.texts.stageEnteredWaiting,
                    false
                );
                setEnteredLook(item, true);
                setButton(item.withdraw, state.texts.withdraw, true);
                setText(item.deadlineNote, state.texts.enteredNote);
            } else {
                setButton(item.enter, state.texts.enter, true);
                setHidden(item.withdraw, true);
            }
            return;
        }

        setHidden(item.deadlineNote, true);
        setHidden(item.withdraw, true);
        setButton(item.enter, state.texts.closedButton, false);
        var stageKey = STAGE_TEXT_KEYS[stage];
        if (stageKey) {
            setText(item.stage, state.texts[stageKey]);
            setHidden(item.stage, false);
        } else {
            // 抽選終了・売切・通常販売への切替・取りやめは、帯を出さない。
            setHidden(item.stage, true);
        }
    }

    function renderAll(state) {
        state.items.forEach(function (item) {
            render(state, item);
        });
        updateBand(state);
        // 中身が変わると行の高さも変わる（締切後・今日締切への切り替わり等）ので、そろえ直す
        equalizeRows(state);
        // 品の見た目が変わると横幅も変わる（応募済みでボタンが入れ替わる等）。
        updateRail(state);
    }

    function applyError(state, item, error) {
        if (error && error.kind === "not_found") {
            // 関所が閉じている＝口が存在ごと隠れている。異常ではないので警告しない。
            item.mode = "gate_closed";
        } else {
            item.mode = "error";
        }
    }

    function loadItem(state, item) {
        if (state.guest || !validRaffleId(item.raffleId)) {
            return Promise.resolve();
        }
        // 🛑 締切後も1回だけは必ず取りにいく。締切後こそ「応募済み・結果待ち」
        //    「抽選済み・まだ確定していない」「確定」の3段階を見せる場面だから（決定102⑤）。
        //    取りにいかないと、応募した方には自分の状態が一生わからない。
        //    1分ごとの更新で取り直さないことは、この下のタイマー側で守っている。
        if (item.loading) {
            return item.loading;
        }
        if (!state.proxy || typeof state.proxy.get !== "function") {
            item.mode = "error";
            render(state, item);
            updateBand(state);
            return Promise.resolve();
        }

        var revision = item.revision;
        var response;
        try {
            response = state.proxy.get(STATUS_PATH, {
                query: {raffle_id: item.raffleId}
            });
        } catch (error) {
            response = Promise.reject(error);
        }
        var request = Promise.resolve(response).then(function (payload) {
            if (revision !== item.revision) {
                return;
            }
            var data = payload && payload.state;
            if (!payload || payload.ok !== true || !data
                    || typeof data !== "object"
                    || typeof data.event_state !== "string") {
                throw new TypeError("raffle status is unavailable");
            }
            item.mode = "ready";
            item.data = viewerState(data);
            if (item.actionBlock && item.data.event_state !== "open") {
                item.actionBlock = "";
            }
            if (item.data.event_state === "unknown") {
                item.element.hidden = true;
                return;
            }
            item.element.hidden = false;
        }).catch(function (error) {
            if (revision !== item.revision) {
                return;
            }
            applyError(state, item, error);
            item.element.hidden = false;
        }).then(function () {
            item.loading = null;
            if (revision !== item.revision) {
                return;
            }
            render(state, item);
            updateBand(state);
        });

        item.loading = request;
        return request;
    }

    function load(state) {
        return Promise.all(state.items.map(function (item) {
            return loadItem(state, item);
        }));
    }

    function applyCode(state, item, result, action) {
        var code = result && result.code;

        if (code === "unknown_raffle") {
            item.element.hidden = true;
            updateBand(state);
            return;
        }
        if (code === "needs_account") {
            item.mode = "guest";
            if (item.signin) {
                item.signin.setAttribute("href", state.loginHref);
            }
            render(state, item);
            return;
        }

        var responseData = result && result.state && typeof result.state === "object"
            ? viewerState(result.state)
            : null;

        if (code === "ok" || code === "already_entered") {
            item.actionBlock = "";
            if (responseData) {
                item.mode = "ready";
                item.data = responseData;
            }
            // 二度押しは「もう入っています」で返る。これは失敗ではない。
            showStatus(state, item, code === "already_entered" || action === "enter"
                ? state.texts.enteredOk
                : state.texts.withdrawnOk);
        } else if (code === "rate_limited") {
            showStatus(state, item, state.texts.rateLimited);
        } else if (code === "account_notice" || code === "contact_notice" || code === "entry_paused") {
            item.actionBlock = "";
            item.mode = "ready";
            item.data = responseData || viewerState(item.data || {});
            item.data.notice = code;
            showStatus(state, item, "");
        } else if (code === "not_open" || code === "closed") {
            item.actionBlock = code;
            if (responseData) {
                item.mode = "ready";
                item.data = responseData;
            }
            showStatus(state, item, "");
        } else {
            showStatus(state, item, state.texts.actionError);
        }

        render(state, item);
        updateBand(state);
    }

    function canSubmit(state, item, action) {
        var data = item.data || {};
        var hasNotice = data.notice === "account_notice"
            || data.notice === "contact_notice"
            || data.notice === "entry_paused";
        if (state.guest || item.mode !== "ready" || item.actionBlock || hasNotice
                || data.event_state !== "open"
                || (item.closesAt !== null && state.now() >= item.closesAt)) {
            return false;
        }
        return action === "cancel"
            ? data.viewer_stage === "entered_waiting"
            : data.viewer_stage !== "entered_waiting";
    }

    // 送り直してよい失敗か（#437）。通信そのものの失敗・混雑（503）・入口が返した 502/504 だけ。
    // ⚠️ 届いていた（答えだけ失われた）こともありうるが、サーバーは同じ申し込み・取り消しを何度受けても
    //    結果が同じなので、送り直しても二重にはならない。
    function notDelivered(error) {
        if (!error || typeof error !== "object") {
            return false;
        }
        if (error.kind === "network" || error.kind === "busy") {
            return true;
        }
        if (error.kind === "server" || error.kind === "not_json") {
            return error.status === 502 || error.status === 503 || error.status === 504;
        }
        return false;
    }

    // 送り直しの前の待ち。全員が同じ秒にそろって送り直さないよう0.75〜1.25倍にばらつかせ、
    // 混雑（503）でサーバーが「N秒後に」と言っていれば、それより短くは待たない（10秒まで）。
    function retryDelay(state, attempt, error) {
        var delay = ENTRY_RETRY_DELAYS_MS[attempt] * (0.75 + 0.5 * state.random());
        if (error && error.kind === "busy" && Number.isFinite(error.retryAfterSeconds)) {
            delay = Math.max(delay, Math.min(error.retryAfterSeconds * 1000, 10000));
        }
        return Math.round(delay);
    }

    function postEntry(state, item, action, attempt, startedAt) {
        var firstSentAt = startedAt === undefined ? state.now() : startedAt;
        // サーバーが許可鍵を厳密に検査するため、通信上の冪等情報は共通部品に任せる。
        var response;
        try {
            response = state.proxy.post(ENTRY_PATH, {
                timeoutMs: ENTRY_TIMEOUT_MS,
                body: {raffle_id: item.raffleId, action: action}
            });
        } catch (error) {
            response = Promise.reject(error);
        }
        return Promise.resolve(response).catch(function (error) {
            if (attempt >= ENTRY_RETRY_DELAYS_MS.length || !notDelivered(error)
                    || state.now() - firstSentAt > ENTRY_RETRY_BUDGET_MS) {
                throw error;
            }
            return state.wait(retryDelay(state, attempt, error)).then(function () {
                return postEntry(state, item, action, attempt + 1, firstSentAt);
            });
        });
    }

    function submit(state, item, action) {
        if (item.busy || !validRaffleId(item.raffleId)
                || !canSubmit(state, item, action)) {
            return Promise.resolve();
        }
        if (!state.proxy || typeof state.proxy.post !== "function") {
            showStatus(state, item, state.texts.actionError);
            return Promise.resolve();
        }

        item.busy = true;
        if (action === "cancel") {
            setButton(item.withdraw, state.texts.withdrawing, false);
        } else {
            setButton(item.enter, state.texts.entering, false);
        }
        showStatus(state, item, "");

        return postEntry(state, item, action, 0).then(function (result) {
            item.revision += 1;
            item.busy = false;
            applyCode(state, item, result, action);
        }).catch(function () {
            item.revision += 1;
            item.busy = false;
            showStatus(state, item, state.texts.actionError);
            render(state, item);
            updateBand(state);
        });
    }

    // ------------------------------------------------------------------------------------------
    // 2026-10-12（store #415・オーナー決定 A案）: 「Enter the draw」を押したら、すぐ送らずに中央の確認の窓を出す。
    //   オーナー「ワンタップで申し込まれてしまうので、一旦確認画面が欲しい」。
    //   中身: 作品の写真・作品名・説明（nk.raffle.confirm_body）・注意（nk.raffle.confirm_warn・#492）・［Not now（confirm_cancel）］［Enter the draw（enter）］。
    //   見出しは置かない（オーナー「1番上の文章いらない」）。Not now・窓の外・Esc で閉じる＝応募しない。
    //   窓は文書に1つだけ作って使い回す（一覧・トップの欄・品のページの3か所で同じ窓）。body の直下に置く＝
    //   品のページの外箱の container-type・トップのカードの transform の中に置くと固定表示が崩れるため。
    //   取り消し（Withdraw）は今までどおり確認なし。文が届いていない古い器では、今までどおりすぐ送る。
    // ------------------------------------------------------------------------------------------
    var CONFIRM_STYLE_ID = "nk-rfc-style";
    var CONFIRM_CSS = [
        // top/right/bottom/left を先に＝inset を知らない古い iOS Safari（14.0 以前）でも画面の外に出ない（見直しの指摘）
        ".nk-rfc{position:fixed;top:0;right:0;bottom:0;left:0;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;",
        "padding:16px;background:rgba(31,42,51,.42);}",
        ".nk-rfc[hidden]{display:none;}",
        ".nk-rfc__card{box-sizing:border-box;width:min(380px,100%);max-height:calc(100% - 32px);overflow:auto;",
        "padding:22px 20px 18px;border-radius:14px;background:#fff;color:#1f2a33;text-align:center;",
        "box-shadow:0 18px 50px rgba(0,0,0,.24);",
        // 先頭の "NK Num"＝数字だけ沈まない字体（assets/nk-numerals.css・全ページで読み込み）。
        // Georgia だけだと 3・4・5・7・9 が下に沈み、「24」「BJ340-690」が崩れて見えた（2026-10-12 オーナー指摘）
        "font-family:\"NK Num\",Georgia,\"Times New Roman\",Times,\"Shippori Mincho\",\"Hiragino Mincho ProN\",\"Yu Mincho\",serif;",
        "-webkit-font-smoothing:antialiased;}",
        ".nk-rfc__img{display:block;width:auto;max-width:100%;max-height:150px;margin:0 auto 12px;border-radius:6px;object-fit:contain;}",
        ".nk-rfc__img[hidden],.nk-rfc__title[hidden]{display:none;}",
        ".nk-rfc__title{margin:0 0 8px;font-size:17px;line-height:1.45;font-weight:400;color:#1f2a33;overflow-wrap:anywhere;}",
        ".nk-rfc__body{margin:0 0 18px;font-size:15px;line-height:1.6;color:#5c6570;}",
        // #492（2026-10-21 オーナー決定 A案）: 選ばれて買わなかったときの注意。説明のすぐ下の薄い札（行の始まりにそろえる）
        ".nk-rfc__warn{margin:-8px 0 18px;padding:10px 12px;border-radius:8px;background:#f6efe3;color:#5a4a26;",
        "font-size:14px;line-height:1.6;text-align:start;overflow-wrap:anywhere;}",
        ".nk-rfc__warn[hidden]{display:none;}",
        ".nk-rfc__row{display:grid;grid-template-columns:1fr 1fr;gap:10px;}",
        ".nk-rfc__btn{display:flex;align-items:center;justify-content:center;min-height:48px;margin:0;padding:10px 14px;",
        "border:1px solid transparent;border-radius:6px;font-family:inherit;font-size:16px;font-weight:400;line-height:1.3;",
        "letter-spacing:.06em;text-transform:none;cursor:pointer;overflow-wrap:anywhere;}",
        ".nk-rfc__btn--ok{background:#2a3743;color:#fff;}",
        ".nk-rfc__btn--ok:hover{background:#1f2a33;color:#fff;}",
        ".nk-rfc__btn--no{background:transparent;color:#1f2a33;border-color:rgba(31,42,51,.28);}",
        ".nk-rfc__btn--no:hover{background:rgba(31,42,51,.05);color:#1f2a33;}",
        ".nk-rfc__btn:focus-visible{outline:2px solid #8a6a2a;outline-offset:2px;}",
        // アラビア文字は字間を空けるとつながりが切れる（応募欄の html[lang="ar"] の決まりは body 直下の窓に届かない）
        "html[lang=\"ar\"] .nk-rfc *{letter-spacing:normal;}",
        // スマホ: 横2つだと「Enter the draw」が2行に折れる＝縦に並べ、応募するを上に（オーナー確認 2026-10-12）
        "@media (max-width:480px){.nk-rfc__row{grid-template-columns:1fr;}.nk-rfc__btn--ok{order:-1;}}"
    ].join("");

    function confirmLayer(documentRef) {
        if (!documentRef || typeof documentRef.createElement !== "function" || !documentRef.body) {
            return null;
        }
        if (documentRef.__nkRaffleConfirm) {
            return documentRef.__nkRaffleConfirm;
        }
        if (typeof documentRef.getElementById !== "function"
                || !documentRef.getElementById(CONFIRM_STYLE_ID)) {
            var style = documentRef.createElement("style");
            style.id = CONFIRM_STYLE_ID;
            style.textContent = CONFIRM_CSS;
            (documentRef.head || documentRef.body).appendChild(style);
        }
        function make(tag, className) {
            var node = documentRef.createElement(tag);
            node.className = className;
            return node;
        }
        var veil = make("div", "nk-rfc");
        veil.hidden = true;
        var card = make("div", "nk-rfc__card");
        card.setAttribute("role", "dialog");
        card.setAttribute("aria-modal", "true");
        card.setAttribute("aria-labelledby", "nk-rfc-title");
        card.setAttribute("aria-describedby", "nk-rfc-body");
        var image = make("img", "nk-rfc__img");
        image.alt = "";
        image.decoding = "async";
        // 写真が読めないとき（404 など）は、壊れた画像の印を出さずに写真ごと隠す
        image.addEventListener("error", function () {
            image.hidden = true;
        });
        var title = make("p", "nk-rfc__title");
        title.id = "nk-rfc-title";
        var body = make("p", "nk-rfc__body");
        body.id = "nk-rfc-body";
        var warn = make("p", "nk-rfc__warn");
        warn.id = "nk-rfc-warn";
        warn.hidden = true;
        var row = make("div", "nk-rfc__row");
        var no = make("button", "nk-rfc__btn nk-rfc__btn--no");
        no.type = "button";
        var ok = make("button", "nk-rfc__btn nk-rfc__btn--ok");
        ok.type = "button";
        row.appendChild(no);
        row.appendChild(ok);
        card.appendChild(image);
        card.appendChild(title);
        card.appendChild(body);
        card.appendChild(warn);
        card.appendChild(row);
        veil.appendChild(card);
        documentRef.body.appendChild(veil);

        var pending = null;
        var returnFocus = null;
        // キーは窓を開いている間だけ文書全体で受ける＝窓の中の文や写真を押して印が body に移っても、
        // Esc で閉じ・Tab で窓の外へ出ない（見直しの指摘）
        function onKeydown(event) {
            if (!event || !pending) {
                return;
            }
            if (event.key === "Escape" || event.key === "Esc") {
                event.preventDefault();
                close(false);
            } else if (event.key === "Tab") {
                // ボタンは2つだけ＝行き来させて、窓の外へ出さない
                event.preventDefault();
                (documentRef.activeElement === ok ? no : ok).focus();
            }
        }
        function close(answer) {
            if (!pending) {
                return;
            }
            var done = pending;
            pending = null;
            veil.hidden = true;
            if (typeof documentRef.removeEventListener === "function") {
                documentRef.removeEventListener("keydown", onKeydown, true);
            }
            if (returnFocus && typeof returnFocus.focus === "function") {
                try {
                    returnFocus.focus();
                } catch (error) {
                    // 戻せなくても応募の流れは止めない
                }
            }
            returnFocus = null;
            done(answer);
        }
        no.addEventListener("click", function () {
            close(false);
        });
        ok.addEventListener("click", function () {
            close(true);
        });
        veil.addEventListener("click", function (event) {
            if (event && event.target === veil) {
                close(false);
            }
        });
        var layer = {
            open: function (options) {
                close(false);
                // ほかの道具に窓を外されていたら body の直下へ戻す
                if (veil.parentNode !== documentRef.body) {
                    documentRef.body.appendChild(veil);
                }
                if (typeof documentRef.addEventListener === "function") {
                    documentRef.addEventListener("keydown", onKeydown, true);
                }
                title.textContent = options.title || "";
                title.hidden = !options.title;
                body.textContent = options.body || "";
                // 注意の文が無い器（古い言語ファイル）では札ごと隠し、読み上げの説明にも入れない
                warn.textContent = options.warn || "";
                warn.hidden = !options.warn;
                card.setAttribute("aria-describedby", options.warn ? "nk-rfc-body nk-rfc-warn" : "nk-rfc-body");
                no.textContent = options.cancel || "";
                ok.textContent = options.ok || "";
                if (options.image) {
                    image.src = options.image;
                    image.hidden = false;
                } else {
                    image.removeAttribute("src");
                    image.hidden = true;
                }
                returnFocus = options.returnFocus || null;
                veil.hidden = false;
                return new Promise(function (resolve) {
                    pending = resolve;
                    try {
                        ok.focus();
                    } catch (error) {
                        // 印が付けられなくても窓は出ている
                    }
                });
            }
        };
        documentRef.__nkRaffleConfirm = layer;
        return layer;
    }

    function confirmEntry(state, item) {
        if (item.busy || item.confirming || !validRaffleId(item.raffleId)
                || !canSubmit(state, item, "enter")) {
            return Promise.resolve();
        }
        var ask = state.confirm;
        if (!ask) {
            var layer = state.texts.confirmBody && state.texts.confirmCancel
                ? confirmLayer(state.documentRef)
                : null;
            if (!layer) {
                // 文や文書が無い古い器では、今までどおりすぐ送る（応募できない形にはしない）
                return submit(state, item, "enter");
            }
            ask = function (current) {
                return layer.open({
                    title: current.title,
                    image: current.image,
                    body: state.texts.confirmBody,
                    warn: state.texts.confirmWarn,
                    cancel: state.texts.confirmCancel,
                    ok: state.texts.enter,
                    returnFocus: current.enter
                });
            };
        }
        item.confirming = true;
        var answer;
        try {
            answer = ask(item);
        } catch (error) {
            answer = false;
        }
        return Promise.resolve(answer).then(function (yes) {
            item.confirming = false;
            // 窓を開いている間に締切を過ぎる・描き直しで状態が変わることがある＝submit が送る前に確かめ直す
            return yes === true ? submit(state, item, "enter") : undefined;
        }, function () {
            item.confirming = false;
        });
    }

    function bindItem(state, item) {
        if (item.enter) {
            item.enter.addEventListener("click", function (event) {
                if (event && typeof event.preventDefault === "function") {
                    event.preventDefault();
                }
                return confirmEntry(state, item);
            });
        }
        if (item.withdraw) {
            item.withdraw.addEventListener("click", function (event) {
                if (event && typeof event.preventDefault === "function") {
                    event.preventDefault();
                }
                return submit(state, item, "cancel");
            });
        }
    }

    function init(root, options) {
        if (!root || !root.dataset || typeof root.querySelectorAll !== "function") {
            return null;
        }
        if (root.dataset.nkRaffleInitialized === "true") {
            return controllers ? controllers.get(root) || null : null;
        }
        root.dataset.nkRaffleInitialized = "true";
        var settings = options || {};
        var documentRef = settings.documentRef || runtime.document || root.ownerDocument;
        var state = {
            root: root,
            documentRef: documentRef,
            proxy: settings.proxy || runtime.NKAppProxy,
            // #415: 応募の前の確認。差し替え（検査など）は「品を受けて true/false（の Promise）を返す関数」
            confirm: typeof settings.confirm === "function" ? settings.confirm : null,
            now: settings.now || function () {
                return Date.now();
            },
            // ⚠️ ブラウザの setInterval / clearInterval は window から切り離して呼ぶと
            //    「Illegal invocation」で落ちる。必ず window の側から呼ぶ形で包む。
            //    （2026-08-30 実ブラウザで初期化ごと落ちるのを実測）
            setIntervalRef: settings.setInterval || function (callback, delay) {
                return runtime.setInterval(callback, delay);
            },
            clearIntervalRef: settings.clearInterval || function (timer) {
                return runtime.clearInterval(timer);
            },
            // 送り直しの前の待ち（#437）。検査では差し替えて待たずに進める
            random: settings.random || Math.random,
            wait: settings.wait || function (delay) {
                return new Promise(function (resolve) {
                    runtime.setTimeout(resolve, delay);
                });
            },
            locale: root.getAttribute("data-nk-raffle-locale") || "",
            guest: root.getAttribute("data-nk-raffle-signed-in") !== "true",
            noticeUrls: {
                account_notice: noticeHref(
                    root.getAttribute("data-nk-raffle-notice-account-url")
                ),
                contact_notice: noticeHref(
                    root.getAttribute("data-nk-raffle-notice-contact-url")
                ),
                // store #440: お問い合わせのページ（account_notice と同じ行き先）
                entry_paused: noticeHref(
                    root.getAttribute("data-nk-raffle-notice-account-url")
                )
            },
            texts: readTexts(root),
            band: find(root, "load-error"),
            retry: find(root, "retry"),
            itemsBox: find(root, "items"),
            rail: find(root, "rail"),
            railThumb: find(root, "rail-thumb"),
            railListeners: [],
            timer: null
        };
        // 差し替えた文書の現在地も使えないと、テストと埋め込み先で戻り先が消えるため。
        state.loginHref = loginHref(
            root.getAttribute("data-nk-raffle-login-url") || "",
            settings.location
                || (documentRef && documentRef.location)
                || runtime.location
        );
        state.items = collectItems(state);

        state.items.forEach(function (item) {
            item.mode = state.guest ? "guest" : "loading";
            bindItem(state, item);
        });
        setHidden(state.band, true);
        renderAll(state);
        setupRail(state);

        if (state.retry) {
            state.retry.addEventListener("click", function (event) {
                if (event && typeof event.preventDefault === "function") {
                    event.preventDefault();
                }
                setHidden(state.band, true);
                state.items.forEach(function (item) {
                    if (item.mode === "error") {
                        item.mode = "loading";
                    }
                });
                renderAll(state);
                return load(state);
            });
        }

        var pageHidden = false;
        var destroyed = false;
        var countdownListeners = [];
        function stopCountdown() {
            if (state.timer !== null) {
                state.clearIntervalRef(state.timer);
                state.timer = null;
            }
        }
        function resumeCountdown() {
            if (destroyed || pageHidden || (documentRef && documentRef.hidden)) {
                stopCountdown();
                return;
            }
            renderAll(state);
            if (state.timer === null && typeof state.setIntervalRef === "function"
                && state.items.some(function (item) {
                    return item.closesAt !== null;
                })) {
                state.timer = state.setIntervalRef(function () {
                    renderAll(state);
                }, 1000);
            }
        }
        function listenCountdown(target, name, listener) {
            if (target && typeof target.addEventListener === "function") {
                target.addEventListener(name, listener);
                countdownListeners.push([target, name, listener]);
            }
        }
        // 非表示中は止め、戻った瞬間に実際の残り時間へ追いつかせる。
        var windowRef = (documentRef && documentRef.defaultView) || runtime;
        listenCountdown(documentRef, "visibilitychange", resumeCountdown);
        listenCountdown(windowRef, "pagehide", function () {
            pageHidden = true;
            stopCountdown();
        });
        listenCountdown(windowRef, "pageshow", function () {
            pageHidden = false;
            resumeCountdown();
        });
        resumeCountdown();

        var controller = {
            reload: function () {
                return load(state);
            },
            enter: function (raffleId) {
                return withItem(state, raffleId, "enter");
            },
            withdraw: function (raffleId) {
                return withItem(state, raffleId, "cancel");
            },
            destroy: function () {
                destroyed = true;
                stopCountdown();
                countdownListeners.forEach(function (entry) {
                    entry[0].removeEventListener(entry[1], entry[2]);
                });
                countdownListeners = [];
                state.railListeners.forEach(function (entry) {
                    if (typeof entry[0].removeEventListener === "function") {
                        entry[0].removeEventListener(entry[1], entry[2]);
                    }
                });
                state.railListeners = [];
            }
        };
        if (controllers) {
            controllers.set(root, controller);
        }

        // 未ログインでは1回も口を叩かない（回数制限が未ログイン共通の枠のため）。
        if (!state.guest) {
            load(state);
        }
        return controller;
    }

    function withItem(state, raffleId, action) {
        var target = null;
        state.items.forEach(function (item) {
            if (item.raffleId === raffleId) {
                target = item;
            }
        });
        return target ? submit(state, target, action) : Promise.resolve();
    }

    function autoInit() {
        if (!runtime.document || typeof runtime.document.querySelectorAll !== "function") {
            return [];
        }
        return Array.prototype.slice.call(
            runtime.document.querySelectorAll("[data-nk-raffle-root]")
        ).map(function (root) {
            return init(root);
        });
    }

    var NKRaffle = {
        init: init,
        autoInit: autoInit
    };

    if (typeof window !== "undefined") {
        window.NKRaffle = NKRaffle;
    }
    if (typeof module !== "undefined" && module.exports) {
        module.exports = NKRaffle;
    }

    if (runtime.document) {
        if (runtime.document.readyState === "loading") {
            runtime.document.addEventListener("DOMContentLoaded", autoInit, {once: true});
        } else {
            autoInit();
        }
    }
})(typeof window !== "undefined"
    ? window
    : (typeof globalThis !== "undefined" ? globalThis : this));
